import { Info, OctagonAlert, TriangleAlert, type LucideIcon } from "lucide-react";

import type { ButtonColor } from "../../atoms/Button/styles";
import { FILL_ROLES } from "../../lib/colors";

export const CONFIRM_DIALOG_VARIANTS = ["default", "warning", "destructive"] as const;

export type ConfirmDialogVariant = (typeof CONFIRM_DIALOG_VARIANTS)[number];

interface ConfirmDialogVariantConfig {
  icon: LucideIcon;
  iconChipClassName: string;
  confirmColor: ButtonColor;
}

export const CONFIRM_DIALOG_VARIANT_CONFIG: Record<ConfirmDialogVariant, ConfirmDialogVariantConfig> = {
  default: { icon: Info, iconChipClassName: FILL_ROLES.info.softBase, confirmColor: "primary" },
  warning: { icon: TriangleAlert, iconChipClassName: FILL_ROLES.warning.softBase, confirmColor: "primary" },
  destructive: { icon: OctagonAlert, iconChipClassName: FILL_ROLES.destructive.softBase, confirmColor: "destructive" },
};
